import { render, staticRenderFns } from "./SysMenuByAddTenantWindow.vue?vue&type=template&id=013d6b81&scoped=true&"
import script from "./SysMenuByAddTenantWindow.vue?vue&type=script&lang=js&"
export * from "./SysMenuByAddTenantWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013d6b81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('013d6b81')) {
      api.createRecord('013d6b81', component.options)
    } else {
      api.reload('013d6b81', component.options)
    }
    module.hot.accept("./SysMenuByAddTenantWindow.vue?vue&type=template&id=013d6b81&scoped=true&", function () {
      api.rerender('013d6b81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/sysMenu/SysMenuByAddTenantWindow.vue"
export default component.exports